import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import FormField from './form-field';

import { formatMessage } from '../../lib/intl';

import '../css/split-purchase-settings.css';

const i18n = defineMessages({
  slotsText: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText',
    defaultMessage: '{count, plural, one {slot} other {slots}}',
  },
  slotsText_adult: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_adult',
    defaultMessage: '{count, plural, one {adult} other {adults}}',
  },
  slotsText_passenger: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_passenger',
    defaultMessage: '{count, plural, one {passenger} other {passengers}}',
  },
  slotsText_ticket: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_ticket',
    defaultMessage: '{count, plural, one {ticket} other {tickets}}',
  },
  slotsText_seat: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_seat',
    defaultMessage: '{count, plural, one {seat} other {seats}}',
  },
  slotsText_item: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_item',
    defaultMessage: '{count, plural, one {item} other {items}}',
  },
  slotsText_shirt: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_shirt',
    defaultMessage: '{count, plural, one {shirt} other {shirts}}',
  },
  slotsText_person: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_person',
    defaultMessage: '{count, plural, one {person} other {people}}',
  },
  slotsText_guest: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_guest',
    defaultMessage: '{count, plural, one {guest} other {guests}}',
  },
  slotsText_player: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_player',
    defaultMessage: '{count, plural, one {player} other {players}}',
  },
  slotsText_student: {
    id: 'splitPurchase.totalCost.dropdownOptions.perSlot.hint.slotsText_student',
    defaultMessage: '{count, plural, one {student} other {students}}',
  },
});

export class SplitPurchasePerSlot extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);

    this.state = {
      setMaxSlots: props.groupMaxSlots,
    };

    this.onSetMaxSlotsChange = this.onSetMaxSlotsChange.bind(this);
  }

  onSetMaxSlotsChange(ev) {
    this.setState({ setMaxSlots: ev.target.checked });
  }

  showMaxSlotsInput() {
    if (!this.props.showMaxSlots) return false;
    return this.state.setMaxSlots;
  }

  renderMinSlots() {
    const fieldProps = {
      name: 'minSlots',
      type: 'number',
      component: FormField,
      min: this.props.minSlots || 2,
      max: this.props.maxSlots || 99,
      normalize: (value) => {
        if (value === '') return 0;
        return parseInt(value, 10);
      },
      onChange: ev => this.props.onMinSlotsChange(ev.target.value),
    };

    return (
      <div>
        <span className="mr-1 inline-part">
          <FormattedMessage
            id="splitPurchase.perSlot.minSlots.label"
            defaultMessage="Require at least"
          />
        </span>
        <div className="inline-part">
          <Field {...fieldProps} />
        </div>
        <span className="mr-1 inline-part">
          {this.formatMessage(i18n.slotsText, { count: this.props.selectedSlots }, this.props.slotName)}
        </span>
      </div>
    );
  }

  renderMaxSlots() {
    if (!this.showMaxSlotsInput()) return null;

    const fieldProps = {
      name: 'maxSlots',
      type: 'number',
      min: this.props.minSlots,
      max: this.props.maxSlots || 99,
      component: FormField,
      normalize: (value) => {
        if (value === '') return 0;
        return parseInt(value, 10);
      },
      onChange: ev => this.props.onMaxSlotsChange(ev.target.value),
    };

    return (
      <div>
        <span className="mr-1 inline-part">
          <FormattedMessage
            id="splitPurchase.perSlot.maxSlots.label"
            defaultMessage="to a max of"
          />
        </span>
        <div className="inline-part">
          <Field {...fieldProps} />
        </div>
      </div>
    );
  }

  renderSetMaxSlotsCheckbox() {
    if (!this.props.showMaxSlots) return null;

    return (
      <div className="mt-3">
        <Field
          name="setMaxSlots"
          type="checkbox"
          component={FormField}
          checkbox="true"
          label={
            <FormattedMessage
              id="splitPurchase.perSlot.setMax.label"
              defaultMessage="Set group maximum."
            />
          }
          onChange={this.onSetMaxSlotsChange}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="split-purchase-per-slot">
        <div className="form-inline h3 form-mixed split-purchase-settings mb-0">
          {this.renderMinSlots()}
          {this.renderMaxSlots()}
          <div className="inline-part">
            <FormattedMessage
              id="splitPurchase.perSlot.toComplete"
              defaultMessage="to make purchase"
            />
          </div>
        </div>
        {this.renderSetMaxSlotsCheckbox()}
      </div>
    );
  }
}

SplitPurchasePerSlot.defaultProps = {
  minSlots: 1,
  maxSlots: 10,
  groupMaxSlots: 2,
  onMinSlotsChange: () => { },
  onMaxSlotsChange: () => { },
  showMaxSlots: true,
  selectedSlots: 1,
}

export default injectIntl(SplitPurchasePerSlot);



// WEBPACK FOOTER //
// ./src/desktop/components/split-purchase.per-slot.js